import { useCallback, useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

import AuctionNavigation from "../auctionNavigation";
import Carousel from "../carousel";
import ConnectWallet from "../connectWallet";
import WalletSelector from "../walletSelector";

import {
  AUCTION_CLAIM_STATES,
  AUCTION_STATES,
  SORT_DIRECTION,
} from "../../models";

import auctionService from "../../services/auction";
import { FiltersContext } from "../../services/context/filters";
import { W3Context } from "../../services/context";

import hammer from "../../assets/hammer.png";

import "./myBidsStyles.css";

const MyBids = ({ onClickConnectWallet }) => {
  const { filters } = useContext(FiltersContext);
  const { active, account } = useContext(W3Context);
  const [displayModal, setDisplayModal] = useState(false);
  const [myBids, setMyBids] = useState([]);

  const getAuctions = useCallback(async () => {
    if (account) {
      const myActiveAndClaimableBids = await auctionService.getAll(
        {
          bidWallet: account,
          state: [AUCTION_STATES.ACTIVE, AUCTION_STATES.SOLD],
          bidderState: [
            AUCTION_CLAIM_STATES.LOCKED,
            AUCTION_CLAIM_STATES.CLAIMABLE,
          ],
          ...filters,
          sort: "expirationDate," + SORT_DIRECTION.ASC,
        },
        { address: account }
      );

      setMyBids(myActiveAndClaimableBids);
    }
  }, [account, filters]);

  useEffect(() => {
    getAuctions();
  }, [getAuctions]);

  return (
    <Container className="my-bids">
      <Row className="title mb-2">
        <p>
          <img src={hammer} alt="auctions" />
          <span className="purple">My</span>
          Bids
        </p>
      </Row>
      <AuctionNavigation onClickConnectWallet={onClickConnectWallet} />
      <Row className="mt-5">
        <Col>
          {!active ? (
            <>
              <ConnectWallet setDisplayModal={setDisplayModal} />
              <WalletSelector
                displayModal={displayModal}
                setDisplayModal={setDisplayModal}
              />
            </>
          ) : (
            <>
              {myBids.length === 0 && Object.keys(filters).length > 0 ? (
                <Container className="no-bids">
                  <Row className="justify-content-center">
                    <Col>There are no auctions that apply to these filters</Col>
                  </Row>
                </Container>
              ) : (
                <Container className="px-0">
                  <Col xs={12}>
                    <Carousel NFTs={myBids} background={false} />
                  </Col>
                </Container>
              )}
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default MyBids;
